import { faker } from '@faker-js/faker'
import { Factory } from 'miragejs'

function random(...args) {
  const items = args || []
  return () => {
    return faker.helpers.arrayElement(items)
  }
}

export default Factory.extend({
  firstName(i) {
    faker.seed(i)
    return faker.person.firstName()
  },
  lastName(i) {
    faker.seed(i)
    return faker.person.lastName()
  },
  gradePosition(i) {
    faker.seed(i)
    return random(5, 6, 7, 8, 9)()
  },
  sisId() {
    return null
  },
  login(i) {
    faker.seed(i)
    return faker.internet.username()
  },

  plainPassword(i) {
    faker.seed(i)
    return faker.internet.password({ length: 5, memorable: true })
  },
})
